import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { MaterialModuleModule } from '../material-module/material-module.module';
import { AboutUsComponent } from './footer/about-us/about-us.component';
import { TermsAndConditionsComponent } from './footer/terms-and-conditions/terms-and-conditions.component';
import { PrivacyComponent } from './footer/privacy/privacy.component';

@NgModule({
  declarations: [
    FooterComponent,
    MainHeaderComponent,
    AboutUsComponent,
    TermsAndConditionsComponent,
    PrivacyComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleModule
  ],
  exports: [
    FooterComponent,
    MainHeaderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [AboutUsComponent, PrivacyComponent, TermsAndConditionsComponent]
})

export class HeaderFooterModuleModule { }
